import React, { Component } from "react";
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Save from '../../../assets/img/svg/save.svg';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import { Grid, Card, Typography, Divider, CardContent, Container, Box, Tooltip } from "@material-ui/core";
import { getprojectbasicinfo } from "../../../actions/AddNewProjectAction";
import withRouter from "../../custom/withRouter";
import { connect } from "react-redux";
import styles from "../../../assets/jss/customStyle"
import $ from "jquery"
import axios from "axios";
import API from "../../../_helpers/endpointService"
import Cancel from "../../../assets/img/svg/cancel.svg"
import { TextField } from "@material-ui/core"
import del from "../../../assets/img/svg/Del.svg"

class ChangePassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isMobile: false,
            menu: true,
            AccessToken: "",
            helper: "",
            helper1: "",
            PasswordError: false,
            ConfirmPasswordError: false,
            cancel: false,
            addData: {
                "Mail": "",
                "Password": "",
                "ConfirmPassword": ""
            }
        }
    }
    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }
    };

    componentDidMount() {
        this.state.addData.Mail = JSON.parse(localStorage.getItem("currentUser")).email;
        this.state.AccessToken = JSON.parse(localStorage.getItem("currentUser")).accessToken;
        this.setState({})
        this.interval = setInterval(() => {
            this.resize()
        }, 10);
    };

    submitMail = (data, access) => {
        let apiUrl = API.CHANGE_PASSWORD;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "POST",
            url: apiUrl,
            data: data,
            headers: {
                'key': access
            }
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.props.navigate(`/projectlist`)
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                }
            });
    };

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    AddCancel1 = () => {
        if (this.state.cancel == true) {
            window.$("#cancelpopup").modal("show");
        }
        else {
            this.props.navigate(`/projectlist`)
        }
    }

    AddCancel = () => {
        window.$("#cancelpopup").modal("hide");
        this.props.navigate(`/projectlist`)
    }

    Save = () => {
        
        let password = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/
       
        if (password.test(this.state.addData.Password)) {
            this.state.PasswordError = false;
        }
        else {
            this.state.PasswordError = true;
            this.state.helper = "Please enter a strong password";
        }
        if (this.state.PasswordError === false) {
            if (this.state.addData.ConfirmPassword === this.state.addData.Password) {
                this.state.ConfirmPasswordError = false;
            }
            else {
                this.state.ConfirmPasswordError = true;
                this.state.helper1 = "Password does not match";
            }
        }
        this.setState({})
        // if (this.state.addData.Password === this.state.addData.ConfirmPassword && this.state.addData.Password !== "" && this.state.addData.ConfirmPassword !== "" && password.test(this.state.addData.Password)) {
        //     this.submitMail(this.state.addData, this.state.AccessToken)
        // }
        if (this.state.PasswordError == false && this.state.ConfirmPasswordError == false) {
            this.submitMail(this.state.addData, this.state.AccessToken)
        }
    }

    handleInputChange = (e, node) => {
        this.state.cancel = true;
        this.state.addData[node] = e.target.value;
        this.setState({});
    }


    componentWillUnmount() {
        clearInterval(this.interval);
    }

    render() {
        const { isMobile } = this.state;
        const { menuToggle, classes } = this.props;
        return (<>
            {
                this.state.isMobile ?
                    <>
                        <div className="row w-100 mt-4">
                            <div className="col-5 w-50 mt-auto">
                                <List className="pt-4 mt-4 " style={{ backgroundColor: "#F6F6F6" }}>
                                    <ListItem onClick={this.sidebar} >
                                        <ListItemText id={"Dashboard" + "1"} className='textNaviIcon' primary="Settings" />
                                        <NavigateNextIcon id="Dashboard" className="naviIcon ml-1" style={{ width: 23, height: 23 }} />
                                        <Divider className='border-bottom' />
                                    </ListItem>
                                </List>
                            </div>
                            <div className="col-7 pt-2 mt-5 w-50 ">
                                <h4 className="pt-2">Change Password</h4>
                            </div>
                        </div>
                    </>
                    :
                    <></>
            }
            <div className="ml-auto scroll-hide" style={{ backgroundColor: "#FFFFFF", width: "100%", marginTop: this.state.isMobile ? '' : -95 }}>
                {
                    this.state.isMobile ?
                        <table className="dataTable border-top" width="100%">
                            <tbody>
                                <tr>
                                    <td className="border-right text-center"><i class="fa fa-arrow-left cursorPointer" onClick={() => this.AddCancel1()}></i></td>
                                    <td className="border-right text-center" >
                                        <button className={`${classes.button}`} onClick={() => this.Save()}><img src={Save} style={{ marginTop: '-4px' }}></img>&nbsp;Save</button>
                                    </td>
                                    <td className=" text-center">
                                        <button className={`${classes.button} `} onClick={() => this.AddCancel1()}><img src={Cancel} style={{ marginTop: '-4px' }}></img>&nbsp;Cancel</button>
                                    </td>
                                    {/* {isEdit ?
                                            <td className="border-left">
                                                <button className={`${classes.button}`} data-target="#deletepopup" data-toggle="modal"><img src={Delete} style={{marginTop:'-4px'}}></img>&nbsp;Delete Project</button>
                                            </td> : <></>} */}
                                </tr>
                            </tbody>
                        </table>
                        :
                        <>
                            <table className="dataTable" width="100%">
                                <tbody>
                                    <tr>
                                        <td width="5%" className="border-right text-center">
                                            <i class="fa fa-arrow-left cursorPointer" onClick={() => this.AddCancel1()}></i></td>
                                        <td className="" width="" style={{ display: 'flex' }}>
                                            <button className={classes.button} onClick={() => this.Save()} style={{ minWidth: '70px' }}><img src={Save} style={{ marginTop: '-4px' }}></img>&nbsp;Save</button>
                                            <button className={`${classes.button}`} onClick={() => this.AddCancel1()} style={{ minWidth: '70px' }}><img src={Cancel} style={{ marginTop: '-4px' }}></img>&nbsp;Cancel</button>
                                        </td>
                                        {/* {isEdit ?
                                                <td className="border-left" width="80%">
                                                    <button className={`${classes.button}`} data-target="#deletepopup" data-toggle="modal"><img src={Delete} style={{ marginTop: '-4px' }}></img>&nbsp;Delete Project</button>
                                                </td> : <></>} */}
                                    </tr>
                                </tbody>
                            </table>
                        </>
                }
                <div style={{ margin: this.state.isMobile ? "auto" : "5px" }}>
                    {this.state.isMobile ? "" : <h6 className="col-12 mx-2 mt-3 ml-1">Change Password</h6>}
                    <div className="row mx-1 px-3 mt-3">
                        <div className={`row mt-2 mx-1 align-items-center ${this.state.isMobile ? "" : "text-row"}`}>

                            <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 mt-2 ${this.state.isMobile ? "border-left border-right border-top col-md-12" : "col-md-3 px-0"}`}>
                                <label className={this.state.isMobile ? "d-flex pt-2" : "float-end text-right d-flex"}>New Password&nbsp;:
                                    <div className={`${classes.helperText}`}>
                                        <div className="MuiFormHelperText-contained">*</div>
                                    </div></label>
                            </div>
                            <div className={`col-12 col-sm-12 pb-4  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1" : "col-md-3 pt-4"}`}>
                                {this.state.PasswordError ?
                                    <TextField
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        error
                                        value={this.state.addData.Password}
                                        type="password"
                                        onChange={(e) => { this.handleInputChange(e, "Password") }}
                                        InputProps={{
                                            className: `border-radius ${classes.inputfieldAlign}`
                                        }}
                                        classes={{ root: classes.helperText1 }}
                                        helperText={this.state.helper}
                                    /> :
                                    <TextField
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        value={this.state.addData.Password}
                                        type="password"
                                        onChange={(e) => { this.handleInputChange(e, "Password") }}
                                        InputProps={{
                                            className: `border-radius ${classes.inputfieldAlign}`
                                        }}
                                    />}
                            </div>

                            <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right" : "mt-2 col-md-3 px-0"}`}>
                                <label className={this.state.isMobile ? "d-flex pt-2" : "float-end d-flex text-right"}>Confirm Password&nbsp;:
                                    <div className={`${classes.helperText}`}>
                                        <div className="MuiFormHelperText-contained">*</div>
                                    </div></label>
                            </div>
                            <div className={`col-12 col-sm-12 pb-4  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1" : "col-md-3 pt-4"}`}>
                                {this.state.ConfirmPasswordError ?
                                    <TextField
                                        variant="outlined"
                                        size="small"
                                        type="password"
                                        fullWidth
                                        error
                                        value={this.state.addData.ConfirmPassword}
                                        onChange={(e) => { this.handleInputChange(e, "ConfirmPassword") }}
                                        InputProps={{
                                            className: `border-radius ${classes.inputfieldAlign}`
                                        }}
                                        classes={{ root: classes.helperText1 }}
                                        helperText={this.state.helper1}
                                    /> :
                                    <TextField
                                        variant="outlined"
                                        size="small"
                                        type="password"
                                        fullWidth
                                        value={this.state.addData.ConfirmPassword}
                                        onChange={(e) => { this.handleInputChange(e, "ConfirmPassword") }}
                                        InputProps={{
                                            className: `border-radius ${classes.inputfieldAlign}`
                                        }}
                                    />}
                            </div>
                        </div>
                    </div>
                </div>
                {/* <div className="row">
                        <div className="col-12 col-sm-12 col-md-2 col-lg-2 col-xl-2 pt-3">
                            <label>New Password :</label>
                        </div>
                        <div className="col-12 col-sm-12 col-md-4 col-lg-3 col-xl-3 pt-3">
                            {this.state.PasswordError ?
                                <TextField
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                    error
                                    value={this.state.addData.Password}
                                    onChange={(e) => { this.handleInputChange(e, "Password") }}
                                    helperText={this.state.helper}
                                    InputProps={{
                                        className: `border-radius ${classes.inputfieldAlign}`
                                    }}
                                    classes={{ root: classes.helperText }}
                                /> :
                                <TextField
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                    value={this.state.addData.Password}
                                    onChange={(e) => { this.handleInputChange(e, "Password") }}
                                    InputProps={{
                                        className: `border-radius ${classes.inputfieldAlign}`
                                    }}
                                />}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 col-sm-12 col-md-2 col-lg-2 col-xl-2 pt-3">
                            <label>Confirm Password :</label>
                        </div>
                        <div className="col-12 col-sm-12 col-md-4 col-lg-3 col-xl-3 pt-3">
                            {this.state.ConfirmPasswordError ?
                                <TextField
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                    error
                                    value={this.state.addData.ConfirmPassword}
                                    onChange={(e) => { this.handleInputChange(e, "ConfirmPassword") }}
                                    helperText={this.state.helper1}
                                    InputProps={{
                                        className: `border-radius ${classes.inputfieldAlign}`
                                    }}
                                    classes={{ root: classes.helperText }}
                                /> :
                                <TextField
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                    value={this.state.addData.ConfirmPassword}
                                    onChange={(e) => { this.handleInputChange(e, "ConfirmPassword") }}
                                    InputProps={{
                                        className: `border-radius ${classes.inputfieldAlign}`
                                    }}
                                />}
                        </div>
                    </div> */}
            </div>
            <div class="modal fade p-5 mt-5" id="cancelpopup" tabindex="-1" role="dialog" aria-labelledby="cancelpopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                <div class="modal-dialog" role="document">
                    <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                        <div class="modal-body pb-0">
                            <h1 className="text-center">
                                <img src={del}></img>
                            </h1>
                            <div className="text-center">
                                <h5 class="fw-bold">The data will be lost. Do you really want to cancel?</h5> </div>
                        </div>
                        <div class="modal-footer border-top-0 m-auto">
                            <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} style={{ backgroundColor: "#00838F", border: "none" }} data-dismiss="modal" onClick={this.AddCancel}><span className="" >Yes</span></button>
                            <button type="button" id="closemodal1" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={()=> window.$("#cancelpopup").modal("hide")} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >No</span></button>
                        </div>
                    </div>
                </div>
            </div>
        </>);
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
        Format: state.AddNewProjectReducer.Format || [],
        settings: state.commonReducer.settings || [],
    };
}

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ChangePassword))
);
